import React, { useState } from 'react'
import { FulfilledByArgos } from '@sainsburys-tech/bolt'
import { ArgosLogo } from '@sainsburys-tech/bolt-icons'

import * as Styled from './ArgosFulfilment.styles'

const ArgosFulfilment = () => {
  const [showFulfillByArgosModal, setShowFulfillByArgosModal] = useState(false)
  return (
    <Styled.FulfilmentMessageContainer data-test='argos-fulfilment'>
      <ArgosLogo width={40} height={40} />
      <Styled.FulfilmentMessage>
        <span>Fulfilled and delivered by Argos.</span>
        <a
          role='link'
          onClick={() => setShowFulfillByArgosModal(true)}
          onKeyPress={() => setShowFulfillByArgosModal(true)}
          tabIndex='0'
        >
          What's this?
        </a>
      </Styled.FulfilmentMessage>
      <FulfilledByArgos
        show={showFulfillByArgosModal}
        toggle={() => setShowFulfillByArgosModal(!showFulfillByArgosModal)}
      />
    </Styled.FulfilmentMessageContainer>
  )
}

export default ArgosFulfilment
